<template>
  <div class="bg-[#181819] px-1">
    <div
      class="bg-gray-600 rounded-2xl w-[76px] text-gray-300 u-center text-sm font-normal p-1 cursor-pointer select-none"
      @click="handleShowHide"
    >
      <div class="ml-1 w-11 flex-shrink-0">
        <span v-if="toggle">{{ $t('main.hide') }}</span>
        <span v-else>{{ $t('main.show') }}</span>
      </div>
      <div class="w-8">
        <MinusCircle v-if="toggle" class="w-5" />
        <MinusPlus v-else class="w-5" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import MinusCircle from '~/static/images/video/minus-circle.svg?inline';
import MinusPlus from '~/static/images/video/plus-circle.svg?inline';

export default defineComponent({
  props: {
    event: {
      type: String,
      require: true,
    },
  },
  components: {
    MinusCircle,
    MinusPlus,
  },
  setup(props, { emit }) {
    // const { $analyticsEvent } = useContext();
    const toggle = ref(true);
    const handleShowHide = () => {
      // $analyticsEvent('Video_Page', 'User_Engagement', `${props.event}_${toggle.value ? 'hide' : 'show'}`);
      toggle.value = !toggle.value;
      emit('hide-show', toggle.value);
    };

    return { handleShowHide, toggle };
  },
});
</script>
